import React, { useEffect, useState } from 'react';
import { ReactComponent as ArrowDown } from 'assets/icons/down-arrow.svg';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/check-icon.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { formatCurrency } from 'utils/functions';
import { ENUM_SELECTION_TYPE } from 'utils/enum';
import { AddonCategoryType } from 'models/addon-category.model';
import { AddonType } from 'models/addon.model';

type Props = AddonCategoryType & {
  onReplace: (a: AddonType, b: AddonType) => void;
  onAdd: (a: AddonType) => void;
  onDelete: (a: AddonType) => void;
  selectedAddons: AddonType[];
  setSelectedAddons: (a: AddonType[]) => void;
};

const CategoryCard = (props: Props) => {
  const [open, setOpen] = useState(true);
  const {
    name,
    summary,
    addons,
    selection_type,
    max_selection,
    onReplace,
    onAdd,
    onDelete,
    selectedAddons,
    setSelectedAddons
  } = props;

  const isSingleSelection = selection_type === ENUM_SELECTION_TYPE.SINGLE_SELECTION;
  const isMultiSelection = selection_type === ENUM_SELECTION_TYPE.MULTI_SELECTION;
  const isMultiSelectionWithQuantity =
    selection_type === ENUM_SELECTION_TYPE.MULTI_SELECTION_WITH_QUANTITY;

  const addAddon = (addon: AddonType) => {
    if (isSingleSelection) {
      if (selectedAddons.find((a) => a.id === addon.id)) deleteAddon(addon);
      else {
        const current = selectedAddons.find((a) => a.id !== addon.id);
        if (current) onReplace(current, addon);
        else onAdd(addon);
        setSelectedAddons([addon]);
      }
    } else if (isMultiSelection) {
      if (selectedAddons.find((a) => a.id === addon.id)) deleteAddon(addon);
      else if (selectedAddons.length < max_selection) {
        onAdd(addon);
        setSelectedAddons([...selectedAddons, addon]);
      }
    } else if (isMultiSelectionWithQuantity) {
      if (selectedAddons.find((a) => a.id === addon.id)) onAdd(addon);
      else if (selectedAddons.length < max_selection) {
        onAdd(addon);
        if (!selectedAddons.find((a) => a.id === addon.id))
          setSelectedAddons([...selectedAddons, addon]);
      }
    }
  };

  const deleteAddon = (addon: AddonType) => {
    setSelectedAddons(selectedAddons.filter((a) => a.id !== addon.id));
    onDelete(addon);
  };

  useEffect(() => {
    setSelectedAddons(addons.filter((a) => a.quantity));
  }, []);
  return (
    <div>
      <div
        className='flex items-center justify-between py-3 px-6 border-b border-b-[#EFF0F0] cursor-pointer'
        onClick={() => setOpen(!open)}>
        <div>
          <h4 className='font-medium text-sm'>{name}</h4>
          <p className='text-[#6F7376] text-xs'>{summary}</p>
        </div>
        {open ? <ArrowDown /> : <ArrowUp />}
      </div>
      {open && (
        <div className='bg-white'>
          {addons.map((addon) => (
            <div
              key={addon.id}
              className={`py-4 px-6 border-b border-b-[#EDEDEE] flex items-center justify-between cursor-pointer hover:bg-[#fbfbfb] select-none ${
                isMultiSelectionWithQuantity && addon.quantity
                  ? 'border-l-4 border-l-[#E60A2B]'
                  : ''
              }`}
              onClick={() => addAddon(addon)}>
              <p className='text-sm'>
                {isMultiSelectionWithQuantity && addon.quantity ? (
                  <span className='text-[#E60A2B]'>
                    {addon.quantity ? addon.quantity + 'x' : ''}&nbsp;&nbsp;&nbsp;
                  </span>
                ) : null}
                {addon.name}{' '}
                {addon.price ? (
                  <span className='text-[#6F7376]'>(+{formatCurrency(addon.price)})</span>
                ) : null}
              </p>
              {addon.quantity ? (
                <span
                  className='w-5 h-5 flex items-center justify-center ml-auto'
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteAddon(addon);
                  }}>
                  {isSingleSelection ? (
                    <span className='w-4 h-4 flex items-center justify-center rounded-full ml-auto bg-[#E60A2B]'>
                      <CheckIcon />
                    </span>
                  ) : isMultiSelection ? (
                    <span className='w-4 h-4 flex items-center justify-center rounded ml-auto bg-[#E60A2B]'>
                      <CheckIcon />
                    </span>
                  ) : (
                    <TrashIcon />
                  )}
                </span>
              ) : !isSingleSelection ? (
                <span className='w-4 h-4 m-[1px] rounded border border-[#D6D8E0] ml-auto hover:border-[#E60A2B]' />
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryCard;
